import * as React from 'react';

const HeadNegativeGraphicSvg = (props: React.SVGProps<SVGSVGElement>) => (
    <svg viewBox="0 0 144 144" {...props}>
        <g
            id="head-negative-graphic_svg__HeadNegitiveGraphic"
            stroke="none"
            strokeWidth={1}
            fill="none"
            fillRule="evenodd"
        >
            <g
                id="head-negative-graphic_svg__head-negative"
                transform="translate(25 24)"
            >
                <path
                    d="M28.35 96V78c0-15-11.937-27.603-11.937-45S33.425 0 50.73 0s34.318 15.603 34.318 33L94 55.5h-8.952V69c0 4.97-4.01 9-8.953 9H64.16v18"
                    id="head-negative-graphic_svg__Fill-1"
                    fill="#DBDAE3"
                    fillRule="nonzero"
                />
                <path
                    d="M50.73 27a25.477 25.477 0 01-6.026 16.5l14.979 9H25.365C11.356 52.5 0 41.084 0 27S11.356 1.5 25.365 1.5C39.375 1.5 50.73 12.916 50.73 27"
                    id="head-negative-graphic_svg__Fill-3"
                    fill="#FFF"
                    fillRule="nonzero"
                />
                <path
                    d="M50.73 27a25.477 25.477 0 01-6.026 16.5l14.979 9H25.365C11.356 52.5 0 41.084 0 27S11.356 1.5 25.365 1.5C39.375 1.5 50.73 12.916 50.73 27z"
                    id="head-negative-graphic_svg__Stroke-5"
                    stroke="#1E0A3C"
                    strokeWidth={3}
                />
                <path
                    d="M43.27 27c0 9.942-8.016 18-17.905 18-9.89 0-17.905-8.058-17.905-18S15.476 9 25.365 9c9.89 0 17.905 8.058 17.905 18"
                    id="head-negative-graphic_svg__Fill-7"
                    fill="#F05537"
                    fillRule="nonzero"
                />
                <path
                    d="M32.825 19.5l-14.92 15"
                    id="head-negative-graphic_svg__Stroke-9"
                    stroke="#FFF"
                    strokeWidth={3}
                />
                <path
                    d="M32.825 34.5l-14.92-15"
                    id="head-negative-graphic_svg__Stroke-11"
                    stroke="#FFF"
                    strokeWidth={3}
                />
            </g>
        </g>
    </svg>
);

HeadNegativeGraphicSvg.displayName = 'HeadNegativeGraphicSvg';
export default HeadNegativeGraphicSvg;
